/**
 * Réglages de l'interface, lus au démarrage.
 *
 * Ils viennent d'un fichier `.env` non versionné, dont `.env.exemple` donne le
 * modèle. Une variable manquante arrête l'application tout de suite, avec le
 * nom du fichier à créer : mieux vaut une erreur claire au démarrage qu'un
 * `undefined` qui se transforme en « connexion impossible » sans raison visible.
 */

function requise(nom: string, valeur: string | undefined): string {
  if (valeur === undefined || valeur.trim() === '') {
    throw new Error(
      `Réglage manquant : ${nom}. Copier apps/web/.env.exemple en apps/web/.env.`,
    );
  }
  return valeur.trim();
}

export const configuration = {
  supabaseUrl: requise('VITE_SUPABASE_URL', import.meta.env.VITE_SUPABASE_URL),
  supabaseClePublique: requise(
    'VITE_SUPABASE_CLE_PUBLIQUE',
    import.meta.env.VITE_SUPABASE_CLE_PUBLIQUE,
  ),
  apiUrl: requise('VITE_API_URL', import.meta.env.VITE_API_URL).replace(/\/+$/, ''),
} as const;
